/**
 * File: press-masonry.js
 *
 * Import and initialize functions for the Press Masonry
 */

export default {
  pressArchives: document.querySelectorAll('.blog_template .masonry_item-1_3'),
  blog_container: document.querySelector('#blog_container'),
  blog_archive: document.querySelector('.blog_archive'),
  init() {
    if (this.pressArchives) {
      this.render();
    }
  },
  render() {
    //relocate masonry inside container
    if (this.blog_archive) this.blog_container.append(this.blog_archive);

    const restructureMasonryItem = (el) => {
      //check if <p> exists inside 'post_info_back' then remove it
      if (el.querySelectorAll('.post_info_back p').length > 0) {
        el.querySelectorAll('.post_info_back p')[0].remove();
      }

      const para = document.createElement("p");
      const node = document.createTextNode(el.querySelectorAll('.post_categories a')[0].innerText);
      para.appendChild(node);
      el.querySelectorAll('.post_info_back')[0].prepend(para);

      //check if <span> exists inside <a> tag then remove it
      if (el.querySelectorAll('.post_title a span').length > 0) {
        const org_html = el.querySelectorAll('.post_title a span')[0].innerHTML;
        el.querySelectorAll('.post_title a span')[0].remove();
        const new_html = "<span>" + org_html + "</span>";
        el.querySelectorAll('.post_title a')[0].innerHTML = new_html;
      } else {
        const org_html = el.querySelectorAll('.post_title a')[0].innerHTML;
        const new_html = "<span>" + org_html + "</span>";
        el.querySelectorAll('.post_title a')[0].innerHTML = new_html;
      }

      //link accessibility naming
      const title = el.querySelector('.post_title span').textContent.trim();
      const dateLink = el.querySelector('.post_date a');
      const date = dateLink.textContent.trim();

      dateLink.setAttribute('aria-label', `${date} ${title}`);
    }
    const pressFunction = () => {
        const pressArchives = document.querySelectorAll('.blog_template .masonry_item-1_3');
        pressArchives.forEach((el) => {
          restructureMasonryItem(el);
        });
    };

    pressFunction();

    const loadMoreBtn = document.getElementsByClassName("nav-load-more")[0];
    if (!loadMoreBtn) return;

    document.addEventListener('resize', () => pressFunction(10));

    const masonry = document.querySelector('.masonry_wrap');
    
    // listen for added child changes
    masonry.addEventListener('DOMNodeInserted', function (e) {
      if (e.target.classList.contains('masonry_item')) {
        restructureMasonryItem(e.target);
      }
    }, false);
  },
};
